var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60421 9.53674e-07L6.8781 9.53674e-07C7.08631 -0.000268936 7.29034 0.0522509 7.46659 0.151481C7.64284 0.250711 7.78409 0.392594 7.874 0.560708C7.97925 0.760175 8.01978 0.982098 7.99099 1.20119C7.9622 1.42027 7.86523 1.62772 7.71115 1.79987L5.0742 4.65948C4.97072 4.76637 4.84278 4.85209 4.69905 4.91084C4.55532 4.96959 4.39916 5 4.24116 5C4.08315 5 3.92699 4.96959 3.78326 4.91084C3.63953 4.85209 3.51159 4.76637 3.40811 4.65948L0.771164 1.79987C0.617078 1.62772 0.520113 1.42027 0.491321 1.20119C0.462528 0.982098 0.503066 0.760175 0.608314 0.560708C0.698221 0.392594 0.839474 0.250711 1.01572 0.151481C1.19197 0.0522509 1.39601 -0.000268936 1.60421 9.53674e-07Z",
    fill: "#333132"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdown_icon.aef1c3296c69a0897b5a26f65e1a76a8.svg";
export { ForwardRef as ReactComponent };